import React from 'react';

function initials(name) {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/);
    const last = parts[parts.length - 1] || '';
    const first = parts.length > 1 ? parts[0] : '';
    return (first.charAt(0) + last.charAt(0)).toUpperCase() || '?';
}

export default function EmployeeCard({ row, onClick, isActive }) {
    const name = row.entity_full_name || row.entity_name || '—';
    const code = row.entity_code || row.code;
    const phone = row.entity_contact_phone;
    const subType = row.entity_sub_type;
    const tags = Array.isArray(row.tags) ? row.tags.slice(0, 3) : [];

    return (
        <div className={'epk-card' + (isActive ? ' epk-card--active' : '')} onClick={() => onClick && onClick(row)}>
            <div className="epk-card__avatar">{initials(name)}</div>
            <div className="epk-card__body">
                <div className="epk-card__head">
                    <span className="epk-card__name">{name}</span>
                    {subType && <span className="epk-card__role">{subType}</span>}
                </div>
                <div className="epk-card__meta">
                    {code && <span className="epk-card__code">{code}</span>}
                    {phone && <span className="epk-card__phone">· {phone}</span>}
                </div>
                {tags.length > 0 && (
                    <div className="epk-card__tags">
                        {tags.map((t) => (
                            <span key={t} className="epk-card__tag">
                                #{t}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
